import React from "react";
import "./EmptyState.scss";

const EmptyState = ({ title }) => {
  return (
    <div className="empty-state-container">
      <div className="empty-state-content">
        <div className="empty-state-title">{title}</div>
      </div>
    </div>
  );
};

export default EmptyState;
